import { useLocation } from 'react-router-dom'

import Notification from ':/_console/js/components/Notification.tsx'
import IntercomLink from '~/components/IntercomLink.tsx'
import type { Workspace } from '~/features/workspaces/types'

interface Props {
  workspace: NonNullable<Workspace>
}

function WorkspaceCancelledBanner(props: Props) {
  const { workspace } = props
  const location = useLocation()
  const isBillingPage = location.pathname.includes('/billing')
  const isSettingsPage = location.pathname.includes('/settings')

  if (!workspace.cancelled || (!isBillingPage && !isSettingsPage)) return null

  return (
    <Notification warning alternative>
      <strong>This Workspace is canceled.</strong> All functionality around Assemblies and Templates
      does not work. To uncancel it, please{' '}
      <IntercomLink message={`Hey, I would like to uncancel the Workspace "${workspace.slug}".`}>
        contact support
      </IntercomLink>
      .
    </Notification>
  )
}

export default WorkspaceCancelledBanner
